// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../vninvestcharts-widget/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../vninvestcharts-widget/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Design Tokens - Backdrop / Glassmorphism */
.vnsc-root {
  --vnsc-backdrop-blur-sm: 4px;
  --vnsc-backdrop-blur-md: 8px;
  --vnsc-backdrop-blur-lg: 16px;
  --vnsc-backdrop-blur-xl: 24px;
  --vnsc-backdrop-saturate: 1.8;
  --vnsc-backdrop-brightness: 0.7;
}
`, "",{"version":3,"sources":["webpack://./src/widget/styles/tokens/backdrop.css"],"names":[],"mappings":"AAAA,6CAA6C;AAC7C;EACE,4BAA4B;EAC5B,4BAA4B;EAC5B,6BAA6B;EAC7B,6BAA6B;EAC7B,6BAA6B;EAC7B,+BAA+B;AACjC","sourcesContent":["/* Design Tokens - Backdrop / Glassmorphism */\r\n.vnsc-root {\r\n  --vnsc-backdrop-blur-sm: 4px;\r\n  --vnsc-backdrop-blur-md: 8px;\r\n  --vnsc-backdrop-blur-lg: 16px;\r\n  --vnsc-backdrop-blur-xl: 24px;\r\n  --vnsc-backdrop-saturate: 1.8;\r\n  --vnsc-backdrop-brightness: 0.7;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
